import { Button } from '@mui/material';
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { purchaseDialogToggled } from '../../store/car-slice';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)<any>(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    fontSize: 10,
    padding: 4,
  },
}));

export default function PurchaseButton() {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(purchaseDialogToggled());
  };

  return (
    <CustomButton
      color="info"
      onClick={handleClick}
      sx={{ bgcolor: '#07A4FC', textTransform: 'capitalize' }}
      variant="contained"
    >
      Purchase Online
    </CustomButton>
  );
}
